import { render, staticRenderFns } from "./checkpage.vue?vue&type=template&id=44377b2c&scoped=true&"
import script from "./checkpage.vue?vue&type=script&lang=js&"
export * from "./checkpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44377b2c",
  null
  
)

export default component.exports